export default __webpack_public_path__ + "static/media/330_business06-nl-web.8bdc5c2d.png";